
export const environment = {
    production: false,
    baseUrl: "https://kakoafrica-customer.public.agilitygis.com/api",
    integrationUrl: 'https://integration.agilitygis.com/api',
    strapiUrl: 'https://kaya-strapi-vm.sudosky.com/api',
    strapiJWTToken: 'Bearer 8f5ad5c39174813c6b1c91457bebf776c0fd708774cc9595b94d2ce9b9b852e826e0de17b09216e19469a7879f0112995d0d4b58708350c14650738a4e5ef7ac0f56b5283ca5f84b5e8e83287509a1217dc501d0a97c443397155dcbc2aa7bf5625c27a283d569704f5ffb056703f2e777076a8bed026ae5bc6d0829ed2c771e',
    recaptchaSiteKeyTest: '6Ld2I9QpAAAAADAclUIc6bCMfXPxb4vki2fP9It-',
    googleAnalyticsCode: '1111',
    imageUrl: "https://kaya-strapi-vm.sudosky.com/api",
    organisationId: '60812466'
};
